import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DividendPayout } from './dividend.types';

type Props = {
  // The dividends API resolves companies/:companyId from the session (@UserInfo), so companyId
  // only keys the cache here — same contract as the other dividend hooks.
  companyId: string;
  enabled?: boolean;
  payoutId: string;
};

export const useDividendPayout = ({ companyId, payoutId, enabled = true }: Props) => {
  const { data: payout, isLoading } = useAppQuery({
    queryKey: [QueryKey.DIVIDEND_PAYOUT, companyId, payoutId],
    queryFn: () =>
      ApiService.get<DividendPayout>({
        endpoint: BackendRoute.DIVIDENDS,
        routePath: [payoutId],
      }),
    enabled: enabled && !!companyId && !!payoutId,
  });

  return { isLoading, payout: payout ?? null };
};
